import { defineComponent as _defineComponent } from 'vue'
import type { Route } from 'vue-router';
import { computed, useContext, useRoute, watch, onMounted, onBeforeUnmount, useRouter } from '@nuxtjs/composition-api';
import { pick } from '@/components/utils/core/object';
import { RESERVED_QUERY_PARAMS } from '~/components/common/constants';
import SignInModal from '~/components/common/SignInModal/SignInModal.vue';
import SignUpModal from '~/components/common/SignUpModal/SignUpModal.vue';
import ContactUsModal from '~/components/common/ContactUsModal.vue';
import SetPasswordModal from '~/components/common/SetPasswordModal.vue';

type ModalEvent = { name: string; params: Record<string, { dynamic_modal: string }> };


export default /*#__PURE__*/_defineComponent({
  __name: 'Modals',
  setup(__props) {

/**
 * @deprecated Please consider registering the component that you want exactly where you need it.
 * By placing it here you are increasing the bundle size for the entire application.
 */
const SignUpPopup = () => import('~/components/common/SignUpPopup/SignUpPopup.vue');
const AnnouncementModal = () => import('~/components/common/AnnouncementModal/AnnoucementModal.vue');
const RestorePasswordModal = () => import('~/components/common/RestorePasswordModal.vue');
const HeaderReferralModal = () =>
  import('~/components/global/HeaderMenu/HeaderReferral/HeaderReferralModal/HeaderReferralModal.vue');
const HeaderReferralHiredModal = () =>
  import('~/components/global/HeaderMenu/HeaderReferral/HeaderReferralHiredModal/HeaderReferralHiredModal.vue');

const { $pages, $modal, $analytics, $sentryUtils } = useContext();
const router = useRouter();
const route = useRoute();

const isWarRoomPages = computed(() => route.value.path.startsWith($pages.POSTS_PAGE.path));

function toggle(route: Route, oldRoute?: Route) {
  const {
    query: { dynamic_modal: modal },
  } = route;

  // FIXME: we must log events not here (by changing route🤯), but in show/hide/toogle
  //        now we don't cover cases when we use $modal.show
  if (oldRoute) {
    const {
      query: { dynamic_modal: oldModal, tab },
    } = oldRoute;
    if (oldModal) {
      $modal.hide(oldModal as string, { silent: true });
      $analytics?.logEvent('global__modal__close', { name: oldModal, tab });
    }
  }

  if (modal) {
    $modal.show(modal as string, route.query);
    $analytics?.logEvent('global__modal__open', { name: modal, tab: route.query.tab });
  }
}

watch(route, toggle);

async function handleClose({ name }: ModalEvent) {
  // closing modals results in triggering nuxt middleware. this is not always desirable (e.g. when closing sign-in modal)
  if (name === route.value.query.dynamic_modal) {
    try {
      await router.replace({ query: pick(route.value.query, RESERVED_QUERY_PARAMS) });
    } catch (e) {
      // fixme: here we silence the errors for duplicated navigation or interrupted navigation
      // this is non-breaking, but must be addressed
      $sentryUtils.error(e);
    }
  }
}

onMounted(() => {
  toggle(route.value);
  $modal.emitter.$on('before-close', handleClose);
});

onBeforeUnmount(() => {
  $modal.emitter.$off('before-close', handleClose);
});

return { __sfc: true,SignUpPopup, AnnouncementModal, RestorePasswordModal, HeaderReferralModal, HeaderReferralHiredModal, $pages, $modal, $analytics, $sentryUtils, router, route, isWarRoomPages, toggle, handleClose, SignInModal, SignUpModal, ContactUsModal, SetPasswordModal }
}

})